import React, { useState, useEffect, useRef, useMemo } from 'react';
import './SlashCommandMenu.css';
import AppIcon from './icons/AppIcon';

const TOOL_CATEGORIES = [
  {
    id: 'consultas',
    label: 'Consultas',
    icon: 'search',
    color: '#44e1ff',
    tools: [
      { command: 'consultar_contatos', label: 'Buscar Contatos', description: 'Buscar contatos por nome, número ou tag', icon: 'person_search' },
      { command: 'consultar_conexoes', label: 'Listar Conexões', description: 'Ver conexões WhatsApp com status', icon: 'cable' },
      { command: 'consultar_agentes', label: 'Listar Agentes', description: 'Ver agentes de IA e configurações', icon: 'smart_toy' },
      { command: 'consultar_projetos', label: 'Listar Projetos', description: 'Ver projetos CRM/Kanban', icon: 'dashboard' },
      { command: 'consultar_cards_projeto', label: 'Cards do Projeto', description: 'Listar cards/leads de um projeto', icon: 'view_kanban' },
      { command: 'consultar_conversas', label: 'Conversas Recentes', description: 'Ver conversas recentes', icon: 'forum' },
      { command: 'ver_mensagens_conversa', label: 'Histórico de Mensagens', description: 'Ver mensagens de uma conversa', icon: 'chat' },
      { command: 'consultar_historico_movimentacoes', label: 'Histórico de Movimentações', description: 'Movimentações de cards entre listas', icon: 'swap_horiz' },
      { command: 'consultar_contato_projetos', label: 'Projetos do Contato', description: 'Ver em quais projetos um contato está', icon: 'account_tree' },
      { command: 'info_empresa', label: 'Info da Empresa', description: 'Informações gerais da empresa', icon: 'business' },
      { command: 'metricas_atendimento', label: 'Métricas', description: 'Métricas de atendimento por período', icon: 'analytics' },
      { command: 'data_hora_atual', label: 'Data e Hora', description: 'Data e hora atual', icon: 'schedule' },
      { command: 'consultar_documentacao', label: 'Documentação', description: 'Consultar documentação do sistema', icon: 'menu_book' },
    ]
  },
  {
    id: 'contatos',
    label: 'Contatos',
    icon: 'contacts',
    color: '#b43bea',
    tools: [
      { command: 'editar_contato', label: 'Editar Contato', description: 'Editar nome, email, tag, status de um contato', icon: 'edit' },
      { command: 'agendar_mensagem', label: 'Agendar Mensagem', description: 'Agendar envio de mensagem via WhatsApp', icon: 'schedule_send' },
      { command: 'mover_contato_projeto', label: 'Mover Contato', description: 'Mover contato entre listas ou projetos', icon: 'drive_file_move' },
    ]
  },
  {
    id: 'projetos',
    label: 'Projetos',
    icon: 'dashboard',
    color: '#6366f1',
    tools: [
      { command: 'criar_projeto', label: 'Criar Projeto', description: 'Criar projeto CRM, Kanban, Tasks ou Custom', icon: 'add_circle' },
      { command: 'editar_projeto', label: 'Editar Projeto', description: 'Editar nome, descrição, ícone e cor', icon: 'edit_note' },
      { command: 'criar_lista_projeto', label: 'Criar Lista', description: 'Criar lista/coluna em um projeto', icon: 'playlist_add' },
      { command: 'editar_lista_projeto', label: 'Editar Lista', description: 'Editar lista existente', icon: 'edit' },
      { command: 'deletar_lista_projeto', label: 'Deletar Lista', description: 'Remover lista de um projeto', icon: 'delete' },
      { command: 'vincular_conexao_projeto', label: 'Vincular Conexão', description: 'Vincular WhatsApp/agente a projeto', icon: 'link' },
      { command: 'configurar_ferramenta_lista', label: 'Automação de Lista', description: 'Configurar mensagem, áudio, imagem automática', icon: 'auto_fix_high' },
      { command: 'solicitar_upload_midia', label: 'Upload de Mídia', description: 'Enviar áudio ou imagem para lista CRM', icon: 'upload_file' },
    ]
  },
  {
    id: 'agentes',
    label: 'Agentes IA',
    icon: 'smart_toy',
    color: '#f59e0b',
    tools: [
      { command: 'criar_agente_ia', label: 'Criar Agente', description: 'Criar novo agente de IA completo', icon: 'add_circle' },
      { command: 'alterar_configuracao_agente', label: 'Configurar Agente', description: 'Alterar nome, temperatura, tokens, etc', icon: 'tune' },
    ]
  },
  {
    id: 'produtos',
    label: 'Produtos',
    icon: 'inventory_2',
    color: '#10b981',
    tools: [
      { command: 'consultar_produtos', label: 'Listar Produtos', description: 'Ver produtos cadastrados', icon: 'list' },
      { command: 'criar_produto', label: 'Criar Produto', description: 'Cadastrar novo produto', icon: 'add_shopping_cart' },
      { command: 'editar_produto', label: 'Editar Produto', description: 'Alterar preço, nome, status, etc', icon: 'edit' },
      { command: 'solicitar_upload_produto', label: 'Foto do Produto', description: 'Enviar foto para um produto', icon: 'add_a_photo' },
      { command: 'consultar_categorias_produtos', label: 'Listar Categorias', description: 'Ver categorias de produtos', icon: 'category' },
      { command: 'criar_categoria_produto', label: 'Criar Categoria', description: 'Criar nova categoria', icon: 'create_new_folder' },
      { command: 'editar_categoria_produto', label: 'Editar Categoria', description: 'Editar categoria existente', icon: 'edit' },
    ]
  },
  {
    id: 'conexoes',
    label: 'Conexões',
    icon: 'phone_iphone',
    color: '#25D366',
    tools: [
      { command: 'criar_conexao', label: 'Criar Conexão', description: 'Criar nova conexão WhatsApp', icon: 'add_circle' },
      { command: 'editar_conexao', label: 'Editar Conexão', description: 'Editar nome, IA, agente vinculado', icon: 'edit' },
      { command: 'conectar_whatsapp', label: 'Conectar WhatsApp', description: 'Gerar QR Code ou código de pareamento', icon: 'qr_code_2' },
      { command: 'desconectar_whatsapp', label: 'Desconectar', description: 'Desconectar número do WhatsApp', icon: 'phone_disabled' },
      { command: 'status_conexao', label: 'Status da Conexão', description: 'Verificar status detalhado', icon: 'info' },
    ]
  },
  {
    id: 'configuracoes',
    label: 'Configurações',
    icon: 'settings',
    color: '#8b5cf6',
    tools: [
      { command: 'alterar_configuracao_empresa', label: 'Dados da Empresa', description: 'Alterar nome, telefone, email, segmento', icon: 'business' },
    ]
  }
];

export { TOOL_CATEGORIES };

export default function SlashCommandMenu({ isOpen, onClose, onSelectCommand, filterText }) {
  const [activeCategory, setActiveCategory] = useState('consultas');
  const [searchFilter, setSearchFilter] = useState('');
  const menuRef = useRef(null);

  // Sincronizar filtro com texto digitado após /
  useEffect(() => {
    setSearchFilter(filterText || '');
  }, [filterText]);

  // Reset categoria quando abre
  useEffect(() => {
    if (isOpen) {
      setActiveCategory('consultas');
    }
  }, [isOpen]);

  // Fechar ao clicar fora
  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        // Não fechar se clicou no botão de abrir ou no input
        if (e.target.closest('.slash-menu-trigger') || e.target.closest('.halo-chat-input input')) return;
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onClose]);

  // Fechar com Escape
  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);

  // Filtrar ferramentas
  const filteredCategories = useMemo(() => {
    if (!searchFilter) return TOOL_CATEGORIES;

    const query = searchFilter.toLowerCase();
    return TOOL_CATEGORIES.map(cat => ({
      ...cat,
      tools: cat.tools.filter(t =>
        t.command.toLowerCase().includes(query) ||
        t.label.toLowerCase().includes(query) ||
        t.description.toLowerCase().includes(query)
      )
    })).filter(cat => cat.tools.length > 0);
  }, [searchFilter]);

  // Quando filtrando, mostrar todas as ferramentas juntas
  const allFilteredTools = useMemo(() => {
    if (!searchFilter) return null;
    return filteredCategories.flatMap(cat =>
      cat.tools.map(t => ({ ...t, categoryColor: cat.color, categoryLabel: cat.label }))
    );
  }, [searchFilter, filteredCategories]);

  const activeCategoryData = TOOL_CATEGORIES.find(c => c.id === activeCategory);

  if (!isOpen) return null;

  return (
    <div className="slash-menu-container" ref={menuRef}>
      <div className="slash-menu-header">
        <AppIcon name="terminal" style={{ fontSize: '18px', color: '#44e1ff' }} />
        <span className="slash-menu-title">Ferramentas</span>
        {searchFilter && (
          <span className="slash-menu-filter-badge">
            /{searchFilter}
          </span>
        )}
      </div>

      <div className="slash-menu-body">
        {/* Modo busca: lista flat */}
        {allFilteredTools ? (
          <div className="slash-menu-search-results">
            {allFilteredTools.length === 0 ? (
              <div className="slash-menu-empty">
                <AppIcon name="search_off" />
                <p>Nenhuma ferramenta encontrada</p>
              </div>
            ) : (
              allFilteredTools.map(tool => (
                <button
                  key={tool.command}
                  className="slash-tool-item"
                  onClick={() => onSelectCommand(tool.command)}
                >
                  <span className="slash-tool-icon" style={{ color: tool.categoryColor }}>
                    <AppIcon name={tool.icon} />
                  </span>
                  <div className="slash-tool-info">
                    <div className="slash-tool-name">
                      <span className="slash-tool-command">/{tool.command}</span>
                    </div>
                    <div className="slash-tool-desc">{tool.description}</div>
                  </div>
                  <span className="slash-tool-category-tag" style={{ color: tool.categoryColor }}>
                    {tool.categoryLabel}
                  </span>
                </button>
              ))
            )}
          </div>
        ) : (
          <>
            {/* Sidebar de categorias */}
            <div className="slash-menu-categories">
              {TOOL_CATEGORIES.map(cat => (
                <button
                  key={cat.id}
                  className={`slash-category-btn ${activeCategory === cat.id ? 'active' : ''}`}
                  onClick={() => setActiveCategory(cat.id)}
                  style={{
                    '--cat-color': cat.color
                  }}
                >
                  <AppIcon name={cat.icon} />
                  <span className="slash-category-label">{cat.label}</span>
                  <span className="slash-category-count">{cat.tools.length}</span>
                </button>
              ))}
            </div>

            {/* Lista de ferramentas da categoria ativa */}
            <div className="slash-menu-tools">
              <div className="slash-tools-header">
                <AppIcon name={activeCategoryData?.icon} style={{ color: activeCategoryData?.color, fontSize: '20px' }} />
                <span>{activeCategoryData?.label}</span>
              </div>
              <div className="slash-tools-list">
                {activeCategoryData?.tools.map(tool => (
                  <button
                    key={tool.command}
                    className="slash-tool-item"
                    onClick={() => onSelectCommand(tool.command)}
                  >
                    <span className="slash-tool-icon" style={{ color: activeCategoryData.color }}>
                      <AppIcon name={tool.icon} />
                    </span>
                    <div className="slash-tool-info">
                      <div className="slash-tool-name">
                        <span className="slash-tool-command">/{tool.command}</span>
                      </div>
                      <div className="slash-tool-desc">{tool.description}</div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
